import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const reset = ({ commit }) => {
  commit(types.CARTE_UPDATE_RESET);
};

export const update = ({ commit }, values) => {
  commit(types.CARTE_UPDATE_SET_ERROR, "");
  commit(types.CARTE_UPDATE_TOGGLE_LOADING);
  axios
    .put(URL_BACKEND + "api-carte/update/" + values.id + "/", values.values)
    .then(() => {
      commit(types.CARTE_UPDATE_SET_UPDATED, true);
      commit(types.CARTE_UPDATE_TOGGLE_LOADING);
    })
    .catch((e) => {
      commit(types.CARTE_UPDATE_TOGGLE_LOADING);
      commit(types.CARTE_UPDATE_SET_ERROR, e.message);
    });
};
